import calcRandomNumberWithMax from "./calc_random_number_with_max";

export const calcRandomInRange = (min, max, decimals) => {

    if (!decimals){
        decimals = 1;
    }
    const factor = Math.pow(10, decimals);

    // Convert range to integers
    const minInt = Math.round(min * factor);
    const maxInt = Math.round(max * factor);

    const range = maxInt - minInt;

    // Use your existing function
    const randomOffset = calcRandomNumberWithMax(range, false, 1);

    return (minInt + randomOffset) / factor;
};

export default calcRandomInRange;